import React, {useEffect, useState, useCallback} from 'react'
import {
  Form,
  Input,
  Select,
  Button,
  Table,
  Row,
  Col,
  message,
  Tooltip,
  Popconfirm,
} from 'antd'
import {EditOutlined, CloseOutlined, DeleteOutlined} from '@ant-design/icons'
import apiRequest from '../../../hooks/ApiRequest'
import Layouts from '../../../components/Layouts'

const {Option} = Select

const RiskCoverItem = ({form}) => {
  const {getFieldDecorator, resetFields, validateFields, setFieldsValue} = form
  const [editId, setEditId] = useState(0)
  const [coverList, setCoverList] = useState([])
  const [riskItems, setRiskItems] = useState([])
  const [tableData, setTableData] = useState([])
  const [productData, setProductData] = useState([])
  const [selectedProductId, setSelectedProductId] = useState('')
  const [selectedRiskId, setSelectedRiskId] = useState('')

  const LoginInsurerId = JSON.parse(localStorage.getItem('insurerId'))
  const columns = [
    {
      key: '1',
      title: 'Cover Name',
      dataIndex: 'riskCoverName',
    },
    {
      key: '2',
      title: 'Risk Items',
      dataIndex: 'riskItemNames',
    },
    {
      key: '3',
      title: 'Minimum Rates',
      dataIndex: 'ratePercentage',
    },
    {
      key: '4',
      title: 'Action',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              type="primary"
              className="edit_btn"
              onClick={() => handleEdit(record?.riskItemId)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            className="delete_btn"
            title="Are you sure you want to delete this record ?"
            onConfirm={() => handleDeleteItem(record.riskItemId)}>
            <Tooltip title="Delete">
              <Button type="danger" style={{marginLeft: 8}}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]
  // console.log('productData', productData);

  const handleDeleteItem = async riskitemid => {
    try {
      const res = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
          `/api/Insurer/DeactivateRiskItem/${riskitemid}`,
        'POST',
      )

      if (res.success) {
        message.success('Risk Item Deleted Successfully !!').then(() => {
          window.location.reload(false)
        })
      } else {
        message.error('Failed to delete risk item.')
      }
    } catch (error) {
      console.error('Delete risk item Error:', error)
      message.error('Failed to delete risk item!')
    }
  }

  const fetchData = useCallback(
    async (productId,riskId) => {
      try {
        const [coverRes, itemRes, listRes, product] = await Promise.all([
          apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${productId}`,
            'GET',
          ),
          apiRequest(
            `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetRiskItemsByCoverId/get-risk-items-by-cover/${riskId}`,
            'GET',
          ),
          apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetAllRiskItemsByInsurerId/${LoginInsurerId}`,
            'GET',
          ),
          apiRequest(
            process.env.REACT_APP_BASE_URL_INSURER +
              `/api/Insurer/GetInsurerProductByInsurerId/${LoginInsurerId}`,
            'GET',
          ),
        ])
        debugger;
        if (coverRes.success) setCoverList(coverRes?.data || [])
        if (itemRes.success) setRiskItems(itemRes?.data?.result || [])
        if (product.success) setProductData(product?.data || [])
        console.log(itemRes)

        if (listRes.success) {
          const formatted = listRes?.data?.map(item => ({
            ...item,
            riskCoverName: item?.riskCover?.riskCoverName || 'N/A',
            riskItemNames: item?.riskItemName,
          }))
          console.log('formattedformatted', formatted)

          setTableData(formatted)
        }
      } catch (error) {
        message.error('Failed to load data')
      }
    },
    [selectedProductId ,selectedRiskId],
  )

  useEffect(() => {
    fetchData(selectedProductId,selectedRiskId)
  }, [fetchData,selectedProductId,selectedRiskId])

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const values = await form.validateFields()
      const payload = {...values}
      const url = editId
        ? `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/update-insurer-riskItem/${editId}`
        : `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/create-Insurer-riskItemMaster`
      const response = await apiRequest(url, 'POST', payload)
      if (response.success) {
        message.success(editId ? 'Risk Item Updated!' : 'Risk Item Added!')
        form.resetFields()
        setEditId(0)
        fetchData()
      } else {
        message.error(response.error || 'Something went wrong.')
      }
    } catch (err) {
      console.error(err)
      message.error('Validation failed or network error.')
    }
  }

  const handleEdit = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskItemById/${id}`,
        'GET',
      )
      if (res.success) {
        const {riskitemName, riskItemId, riskItemPercentage} = res.data
        setEditId(riskItemId)
        setFieldsValue({
          riskItemName: riskitemName,
          ratePercentage: riskItemPercentage,
        })
      }
    } catch (error) {
      message.error('Failed to fetch item details')
    }
  }

  const handleDelete = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/DeleteRiskItem/${id}`,
        'GET',
      )
      if (res.success) {
        message.success('Deleted successfully')
        fetchData()
      } else {
        message.error('Delete failed')
      }
    } catch {
      message.error('Network error during delete')
    }
  }
  const handleProductChange = value => {
    const selected = productData.find(p => p.productId === value)
    if (selected) {
      setSelectedProductId(selected.productId)
    }
  }
  const handleRiskChange = value => {
    const selected = productData.find(p => p.productId === value)
    if (selected) {
      setSelectedProductId(selected.productId)
    }
  }
  return (
    <Layouts title="Risk Cover Item" classname="dashboard">
      <div className="dash-bg-white">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  ManageInsurer Risk Item
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            {editId ? (
              <>
                <Col md={8}>
                  <Form.Item label="Name">
                    {getFieldDecorator('riskItemName', {
                      rules: [{required: true, message: 'Name is required'}],
                    })(<Input placeholder="Enter Risk Item Name" />)}
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item label="Minimum Rate">
                    {getFieldDecorator('ratePercentage', {
                      rules: [
                        {required: true, message: 'Minimum Rate is required'},
                      ],
                    })(<Input placeholder="Enter Minimum premium rate" />)}
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                <Col lg={10}>
                  <Form.Item label="Select Products">
                    {getFieldDecorator('insurerProductId', {
                      rules: [
                        {
                          required: true,
                          message: 'Please select product',
                        },
                      ],
                    })(
                      <Select
                        placeholder="Select Products"
                        onChange={handleProductChange}>
                        {productData?.map(product => (
                          <Option
                            key={product?.productId}
                            value={product?.productId}>
                            {product?.productName}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col lg={10}>
                  <Form.Item label="Select Risk Cover">
                    {getFieldDecorator('insurerRiskCoverId', {
                      rules: [{required: true, message: 'Select Risk Cover'}],
                    })(
                      <Select
                        placeholder="Select Risk Cover"
                        onSelect={(riskCoverId, option) => {
                         setSelectedRiskId(option.props.masterid);
                        }}>
                        {coverList.map(item => (
                         <Option
                            key={item?.riskCoverId}
                            value={item?.riskCoverId}
                            masterid={item?.masterRiskCoverId}>
                            {item?.riskCoverName}
                         </Option>
                        ))}
                     </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col lg={10}>
                  <Form.Item label="Select Risk Items">
                    {getFieldDecorator('riskItemIds', {
                      rules: [{required: true, message: 'Select Risk Items'}],
                    })(
                      <Select mode="multiple" placeholder="Select Risk Items">
                        {riskItems.map(item => (
                          <Option
                            key={item?.riskitemid}
                            value={item?.riskitemid}>
                            {item?.riskitemname}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              </>
            )}
            <Col lg={4}>
              <Button type="primary" htmlType="submit" className="m-t-22">
                {editId ? 'Update' : 'Add'}
              </Button>
            </Col>
          </Row>
        </Form>

        <div className="table-grid-bx m-t-30">
          <Table
            columns={columns}
            dataSource={tableData}
            rowKey="insurerRiskItemId"
            pagination={false}
          />
        </div>
      </div>
    </Layouts>
  )
}

export default Form.create()(RiskCoverItem)
